// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"ef96525b","235":"2738d333","377":"7333d675","700":"49d31458","876":"0aaf0afd","970":"a77e9412"}[chunkId] + ".chunk.css";
};